// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
require('./sensorsdata.js')
require('../home.css');
require('../en.css')
if(language=='zh-CN'){
    $('body').removeClass('en')
}else{
    $('body').addClass('en')
}
// if(language=='zh-CN'|| language=='USA'){
// }else{
//     $('.joinUs_hotelPic_thumb_arula').hide()
//     $('.no-args').hide()
// }
var Config = require('../config/config.js');
var url_prefix = Config.env[Config.scheme].prefix;
var riyuMap = require('../images/home/list/riyuMap.png')
var hanyuMap = require('../images/home/list/hanyuMap.png')
var taiyuMap = require('../images/home/list/taiyuMap.png')
var yueyuMap = require('../images/home/list/yueyuMap.png')
if(language=='JP'){
    $('.map_en').attr('src',riyuMap);
}else if(language=='KO'){
    $('.map_en').attr('src',hanyuMap);
}else if(language=='TH'){
    $('.map_en').attr('src',taiyuMap);
}else if(language=='YH'){
    $('.map_en').attr('src',yueyuMap);
}
$('.commonJoinInCooperation').addClass('select');
$('.reservation').css('color', 'white');

$('.reservationCode .close ,.reservationCode .guanbi').on('click', function () {
    $('.reservationCode').fadeOut(300);
    $('.reservation').css('opacity', 1);
});
var width = document.documentElement.clientWidth;

$(window).resize(function () {
  //当浏览器大小变化时
  width = document.documentElement.clientWidth;
});
$('.language').on('mouseover',function() {
    $(".choicelanguage").show();
}).on('mouseout',function() {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
    console.log(window.location)
    window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language','zh-CN')
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click',function(){
    localStorage.setItem('language','USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
     //window.location.reload();
})
$('.choicelanguage a').eq(2).on('click',function(){
 localStorage.setItem('language','JP');
window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
     //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click',function(){
   localStorage.setItem('language','KO');
window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
     //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
   localStorage.setItem('language','TH');
window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
    //window.location.reload();
})
$('.choicelanguage a').eq(5).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
     //window.location.reload();
 })
$(".about1").on('mouseover', function () {
    $(".aboutLv").show();
})
$(".about1").on('mouseout', function () {
    $(".aboutLv").hide();
})
$(".brand1").on('mouseover', function () {
    $(".choiceBrand").show();
}).on('mouseout', function () {
    $(".choiceBrand").hide();
})
$('.submitInfo_input_1').on('click', function () {
    $('.select_forJoinUs').slideToggle();
});
$('.select_forJoinUs span').on('click', function () {
    $('.submitInfo_input_joinUs').html($(this).html());
});
$('body').on('click', function (e) {
  if (e.target.className != "submitInfo_input_joinUs homePageSwiperFiveJoin" && e.target.className != "submitInfo_input submitInfo_input_1") {
    $('.select_forJoinUs').slideUp();
  }
})
$(".submitInfo_submit").on("click", submitInfo)
function submitInfo() {
    if (!$(".submitInfo_name").val()) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputName[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
     // 判断国外手机号不能为空
     if($(".submitInfo_phone").val()==''){
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    // 只有中国走手机号判断
    if(language == 'zh-CN'){
        if (!(/^1[34578]\d{9}$/.test($(".submitInfo_phone").val()))) {
            $(".submitInfo_tips_1").html(homePageSwiperFiveInputPhoneError[language]);
            $(".submitInfo_submit").off("click", submitInfo);
            $(".submitInfo_tips_1").show();
            setTimeout(function () {
                $(".submitInfo_tips_1").hide();
                $(".submitInfo_submit").on("click", submitInfo);
            }, 1500);
            return;
        }
    }
    
    if($(".submitInfo_name").val().length>50){
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputNameLong[language]);
        $(".submitInfo_submit").off("click",submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function(){
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click",submitInfo)
        },1500);
        return;
    }
    if($(".submitInfo_address").val().length>50){
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressLong[language]);
        $(".submitInfo_submit").off("click",submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function(){
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click",submitInfo)
        },1500);
        return;
    }
    if (!$(".submitInfo_address").val()) {
        $(".submitInfo_tips_1").html(homePageSwiperFiveInputAddressError[language]);
        $(".submitInfo_submit").off("click", submitInfo);
        $(".submitInfo_tips_1").show();
        setTimeout(function () {
            $(".submitInfo_tips_1").hide();
            $(".submitInfo_submit").on("click", submitInfo)
        }, 1500);
        return;
    }
    sensors.track("formSubmit",{"name":$('.submitInfo_name').val(),'phone_number':$(".submitInfo_phone").val(),'address':$(".submitInfo_address").val(),'form_entrance':'PC加盟页'
});
    $(".submitInfo_submit").off("click", submitInfo);
  
    $.ajax({
      url: url_prefix + '/mng/api/pcms/league/create.json',
        type: 'POST',
        data: {
            name: $(".submitInfo_name").val(),
            mobile:$(".submitInfo_phone").val(),
            address:$(".submitInfo_address").val(),
            dataSource:parseInt(GetQueryString('source'))?parseInt(GetQueryString('source')):1
        },
        dataType: 'json',
        timeout: 5000,
        success: function (res) {
            if (res.success) {
                //埋点信息
                _agtjs('loadEvent',{atsev:101,'atsusr': $(".submitInfo_name").val(),'atsykc':$(".submitInfo_phone").val()});
              
                $(".submitInfo_tips_1").html(commonCompanyCubmitSuccess[language]);
                $(".submitInfo_tips_1").show();
                $(".submitInfo_name").val("");
                $(".submitInfo_phone").val("");
                $(".submitInfo_address").val("");
                setTimeout(function () {
                    $(".submitInfo_tips_1").hide();
                    $(".submitInfo_submit").on("click", submitInfo);
                }, 1500);
            } else {
                $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
                $(".submitInfo_tips_1").show();
                setTimeout(function () {
                    $(".submitInfo_tips_1").hide();
                    $(".submitInfo_submit").on("click", submitInfo);
                }, 1500);
            }

        },
        error: function (error) {
            $(".submitInfo_tips_1").html(commonCompanyCubmitFail[language]);
            $(".submitInfo_tips_1").show();
            setTimeout(function () {
                $(".submitInfo_tips_1").hide();
                $(".submitInfo_submit").on("click", submitInfo);
            }, 1500);
            $(".submitInfo_submit").on("click", submitInfo);
        }
    });
}
$("img").on('dragstart',function(){
    return false;
})

function placeholderSupport() {
    return 'placeholder' in document.createElement('input');
}

    function placeholder(target){

             $(target).val($(target).attr("datavalue")).addClass("inp");
             $(target).focus(function() {
                 if($(this).val() == $(this).attr("datavalue")) {
                     $(this).val("").removeClass("inp");
                 }

             })
             $(target).blur(function(){
                 if($(this).val() == "" || $(this).val() == $(this).attr("datavalue")) {
                     $(this).val($(target).attr("datavalue")).addClass("inp");
                 }
             })
     }

if(!placeholderSupport()){
    placeholder(".submitInfo_name")
    placeholder(".submitInfo_phone")
    placeholder(".submitInfo_address")
    placeholder(".ipt")
}


window.smallImgIndex=0;
window.smallImgIncludeIndex=0;

$('.joinUs_hotelPic_slider li').click(function () {
   smallImgIncludeIndex = $(this).index();
   // 屏蔽酒店实拍点击
   if (language == 'zh-CN' && smallImgIncludeIndex >= 6) {
    return;
   }
   if ((language == 'KO' || language == 'TH' || language == 'YH') && smallImgIncludeIndex >= 4) {
    return;
   }
   var classArr = ['swiper-floral','swiper-vyluk','swiper-suoxing','swiper-arula','swiper-baina','swiper-banlan','swiper-beu'];
   var thunmClassArr = ['.joinUs_hotelPic_thumb_floral','.joinUs_hotelPic_thumb_vyluk','.joinUs_hotelPic_thumb_suoxing','.joinUs_hotelPic_thumb_arula','.joinUs_hotelPic_thumb_baina','.joinUs_hotelPic_thumb_banlan','.joinUs_hotelPic_thumb_beu'];
   $('.swiper-wrapper').attr('class','swiper-wrapper '+classArr[smallImgIncludeIndex]);
   $('.joinUs_hotelPic_thumb ul').hide();
   $(thunmClassArr[smallImgIncludeIndex]).show();
   $(this).addClass('current').siblings().removeClass('current');
   smallImgIndex = 0;
   mySwiper.slideTo(smallImgIndex+1,500);
    mySwiper.autoplay.start();
    $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select')
});

$('.joinUs_hotelPic_thumb li').on('click',function () {
    smallImgIndex = $(this).index();
    mySwiper.slideTo(smallImgIndex+1,500);
    mySwiper.autoplay.start();
    $(this).find('span').addClass('select');
    $(this).siblings().find('span').removeClass('select');
});
$('.joinUs_hotelPic_thumb li').mouseover(function () {
    $(this).css({transform:'translateY(-10px)',padding:'0 0 10px 0'});
    $(this).find('span').addClass('select');
    $(this).siblings().find('span').removeClass('select');
}).mouseout(function () {
    $(this).css({transform:'translateY(0px)',padding:'0 0 0px 0'});
    $(this).find('span').removeClass('select');
    $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select')
});


var mySwiper = new Swiper('.swiper-container', {
    autoplay:{
        delay:3000
    },
    speed:1000,
   // autoplayDisableOnInteraction : false,
    paginationClickable :true,
    disableOnInteraction:false,
    loop: true, // 循环模式选项
    // 如果需要前进后退按钮
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on: {
        slideChange: function () {
            $('.joinUs_hotelPic_thumb li').find('span').removeClass('select');
            smallImgIndex = this.activeIndex-1;
            if(this.activeIndex == 6){
                smallImgIndex = 0;
            }
            $('.joinUs_hotelPic_thumb ul').eq(smallImgIncludeIndex).find('li').eq(smallImgIndex).find('span').addClass('select')
        },
    },
})




function GetQueryString(name)
{
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
}





/** WEBPACK FOOTER **
 ** ./src/js/joinUs.js
 **/